/**
 * @generated SignedSource<<571b259a685270f792d24c9400553ce2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FunnelListTab_site$data = {
  readonly id: string;
  readonly name: string;
  readonly slug: string;
  readonly funnels: {
    readonly __id: string;
    readonly totalCount: number;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly slug: string;
        readonly id: string;
        readonly name: string;
        readonly " $fragmentSpreads": FragmentRefs<"FunnelTableDataRow_funnel">;
      } | null;
    } | null> | null;
  };
  readonly funnelCsv: any;
  readonly " $fragmentType": "FunnelListTab_site";
};
export type FunnelListTab_site = FunnelListTab_site$data;
export type FunnelListTab_site$key = {
  readonly " $data"?: FunnelListTab_site$data;
  readonly " $fragmentSpreads": FragmentRefs<"FunnelListTab_site">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "funnels"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v4 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v5 = {
  "kind": "Variable",
  "name": "searchText",
  "variableName": "searchText"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 120,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "onlyExperiment"
    },
    {
      "defaultValue": {
        "direction": "ASC",
        "field": "NAME"
      },
      "kind": "LocalArgument",
      "name": "orderBy"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "searchText"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "withArchived"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./FunnelListTab_Query.graphql'),
      "identifierField": "id"
    }
  },
  "name": "FunnelListTab_site",
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": "funnels",
      "args": [
        {
          "kind": "Variable",
          "name": "onlyExperiment",
          "variableName": "onlyExperiment"
        },
        (v4/*: any*/),
        (v5/*: any*/),
        {
          "kind": "Variable",
          "name": "withArchived",
          "variableName": "withArchived"
        }
      ],
      "concreteType": "FunnelConnection",
      "kind": "LinkedField",
      "name": "__FunnelListTab_funnels_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FunnelEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Funnel",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "FunnelTableDataRow_funnel"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        (v4/*: any*/),
        (v5/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "funnelCsv",
      "storageKey": null
    }
  ],
  "type": "Site",
  "abstractKey": null
};
})();

(node as any).hash = "659668ae4babbce590b8761f0a9e78b9";

export default node;
